export default __webpack_public_path__ + "static/media/stripe.fa4f4f3b.svg";